import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** video camera. Decorative line icon; always pair with a visible text label. */
export function VideoIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <rect x="3" y="6.5" width="12.5" height="11" rx="2" />
      <path d="M15.5 10.7l5-3v8.6l-5-3" />
    </IconSvg>
  )
}
